import { CustomCellRendererProps } from "ag-grid-react";
import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import { ConsultantRowData } from "../../../utils/consultant-row-data";
import { EditFilledIcon } from "@bonliva-crm/ui";
import { ConsultantTableContext } from "../consultant-table";

export const QualityNoteRenderer = (
  props: CustomCellRendererProps<ConsultantRowData, any, ConsultantTableContext>
) => {
  const classes = useStyles();

  if (!props.data) {
    return null;
  }

  return (
    <Grid container direction={"row"} alignItems={"center"} spacing={1} wrap={"nowrap"}>
      <Grid item>
        <Typography variant={"body2"} className={classes.qualityNote}>
          {props.data?.qualityNote || "-"}
        </Typography>
      </Grid>
      <Grid item>
        <IconButton
          className={classes.iconButton}
          onClick={(e) => {
            e.preventDefault();

            props.context.setQualityNoteData({
              consultantId: props.data?._id,
              qualityNote: props.data?.qualityNote ?? ""
            });
          }}
        >
          <EditFilledIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  qualityNote: {
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    wordBreak: "break-word"
  },
  iconButton: {
    padding: 0
  }
}));
